import { ProductBlockCaption } from './components/ProductBlockCaption/ProductBlockCaption.js';
import { ProductBlockHeading } from './components/ProductBlockHeading/ProductBlockHeading.js';
import { ProductBlockDetails as ProductBlockDetails$1 } from './ProductBlockDetails.js';

const ProductBlockDetails = Object.assign(ProductBlockDetails$1, {
    Caption: ProductBlockCaption,
    Heading: ProductBlockHeading
});

export { ProductBlockDetails };
//# sourceMappingURL=index.js.map
